import { applyOrgRedirect, fetchJSON } from "./utils";

/**
 * Fetches all organizations available to the user or matching the provided id / code
 * @param {string} org_id
 * @param {string} org_code
 * @returns
 */
export async function fetch(
  org_id = null,
  org_code = null,
  showErrorToast = true
) {
  let url = "/api/organization/";
  const params = {};
  if (org_id) {
    url += org_id;
  }
  if (org_code) {
    params.org_code = org_code;
  }
  return await fetchJSON(url, params, null, "get", showErrorToast);
}

export async function fetchMyOrganization(organization_id = null) {
  const params = {};
  if (organization_id) {
    params.organization_id = organization_id;
  }
  const url = "/api/organization/mine";
  const response = await fetchJSON(url, params, null, "get");
  return applyOrgRedirect(response);
}

export async function updateOrganizationPropertiesApi(
  organizationId = null,
  updateData
) {
  if (organizationId === null) return;

  const url = `/api/organization/${organizationId}/fields`;

  try {
    const response = await fetchJSON(url, null, { updates: updateData }, "put");
    return response;
  } catch (error) {
    console.error("Error updating organization:", error);
    throw error;
  }
}

export async function getLogoPresignedUrl(organizationId, key) {
  const url = `/api/organization/${organizationId}/logo`;
  return await fetchJSON(url, null, { key }, "post");
}

export function getSetting(organizationId, key) {
  const url = `/api/organization/${organizationId}/setting/${key}`;
  return fetchJSON(url, null, null, "get", false);
}

export function saveSetting(organizationId, key, data) {
  const url = `/api/organization/${organizationId}/setting/${key}`;
  return fetchJSON(url, null, data, "put", false);
}
